export const METIERSIMMMO = ['AGENCE', 'BAILLEUR_SOCIAL', 'CMI', 'ETUDE', 'MANDATAIRE_IMMO', 'MARCHAND_DE_BIEN']

export const PROMOTEUR = ['PROMOTEUR']

export const METIERSVO = ['CONCESSIONNAIRE', 'CONCESSIONNAIRE_MOTO', 'GARAGE', 'MANDATAIRE_AUTO', 'REPARATEUR_AGREE', 'SPECIALISTE_VO']
